<script>
    // Import general mixin for shared functionality.
    import mixin from './../mixin';

    import SourceSet from './SourceSet.vue';

    export default {
        mixins: [mixin],
        components: { SourceSet },
        props: {
            item: Object,
            itemClass: String
        }
    }
</script>

<template>
    <a :href="item.detailUrl" :class="['card', 'card--imagelink', itemClass]">
        <div class="card-image">
            <div v-if="item.genres && item.genres.length" class="event-genres tags">
                <span v-for="genre in item.genres" :key="genre.id" class="tag">{{ genre.name }}</span>
            </div>
            <source-set :imageSets="item.imageSets" class-name="widget-tips-image"  alias="previewImageTips_" v-if="item.imageSets && item.imageSets.length" />
        </div>
        <div class="card-content">
            <h3 v-if="item.performer" class="title is-7 event-title mb-3 has-text-weight-semibold">{{ item.performer }}</h3>
            <p v-if="item.title" class="block has-text-weight-medium is-size-11 mt-auto">{{ item.title }}</p>
            <p v-else-if="item.subTitle" class="block has-text-weight-medium is-size-11 mt-auto">{{ item.subTitle }}</p>
        </div>
    </a>
</template>
